<template>
  <div class="language-switcher" role="group" :aria-label="$t('languageSwitcher.label')">
    <template v-for="(code, index) in locales" :key="code">
      <span v-if="index > 0" class="separator" aria-hidden="true">/</span>
      <button type="button" class="locale-button" :class="{ active: code === $locale }" :lang="code"
        :aria-pressed="code === $locale" @click="$setLocale(code)">
        {{ labels[code] }}
      </button>
    </template>
  </div>
</template>

<script>
import { SUPPORTED_LOCALES, LOCALE_LABELS } from "@/i18n/config.js";

export default {
  name: "LanguageSwitcher",
  data() {
    return {
      locales: SUPPORTED_LOCALES,
      labels: LOCALE_LABELS,
    };
  },
};
</script>

<style scoped>
.language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-mono);
  font-size: 14px;
  letter-spacing: 0.1em;
  vertical-align: middle;
}

.separator {
  color: var(--text-secondary);
}

.locale-button {
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 2px 6px;
  font: inherit;
  letter-spacing: inherit;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.3s ease, border-color 0.3s ease, text-shadow 0.3s ease;
}

.locale-button:hover {
  color: var(--accent-neon);
  text-shadow: 0 0 8px rgba(0, 240, 255, 0.5);
}

.locale-button:focus-visible {
  outline: none;
  border-color: var(--accent-neon);
}

.locale-button.active {
  color: var(--accent-primary);
  border-color: var(--accent-primary);
  text-shadow: 0 0 10px rgba(255, 152, 0, 0.3);
  cursor: default;
}
</style>
